<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    @if (!isEditing) {
      {{'psychologist.subtitle' | translate}}
    } @else {
      {{'psychologist.update' | translate}}
    }
  </div>
  <div class="form-container">
    <form [formGroup]="registerForm" class="form">
      <app-input 
        [label]="'labels.council_number' | translate"
        [placeholder]="'placeholders.council_number' | translate"
        [formControl]="councilNumberControl"
        type="text"
      ></app-input>      

      <app-input 
        [label]="'labels.council_country' | translate"
        [placeholder]="'placeholders.council_country' | translate"
        [formControl]="councilCountryControl"
        [autocompleteList]="COUNTRIES"
        [autocompleteOptionLabel]="'name'"
        [autocompleteDisplayFunction]="autocompleteDisplayFn"
        type="autocomplete"
      ></app-input>

      <p class="label">Session language</p>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="sessionLanguageControl" multiple>
          @for (item of LANGUAGES; track item.code) {
            <mat-option [value]="item.code">{{item.name | translate}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (
        sessionLanguageControl.invalid 
        && sessionLanguageControl.errors
        && (sessionLanguageControl.touched || sessionLanguageControl.dirty)
      ) {
        @if (sessionLanguageControl.errors['required']) {
          <div class="error">
            {{ 'errors.field_required' | translate }}
          </div>
        } @else {
          <div class="error">
            {{ 'errors.invalid_field' | translate }}
          </div>
        }
      }

      <div class="text-area-container">
        <app-text-area
          [label]="'labels.describe_your_service'| translate"
          [control]="descriptionControl"
        ></app-text-area>
      </div>

      <div class="checks-container">
        <mat-checkbox 
          class="custom-checkbox" 
          [class.required]="acceptInputIsLegitCheckControl.invalid 
            && (acceptInputIsLegitCheckControl.touched || acceptInputIsLegitCheckControl.dirty)"
          [formControl]="acceptInputIsLegitCheckControl">
            {{'labels.input_is_legit' | translate}}
        </mat-checkbox>
        <p>{{'labels.read_input_is_legit' | translate}}</p>
      </div>
    </form>

    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="cancel()">
      </app-button>
      
      <app-button
        [buttonLabel]="'buttons.submit' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="isEditing ? updateProfile() : requestRegister()">
      </app-button>
    </div>
    
  </div>
</div>